import axios from "axios";
import config from "../config";

export const validate = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/auth/login`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const register = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/auth/register`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const verify = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/auth/verify`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const requestPasswordReset = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/auth/forgot-password`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}

export const resetPassword = async (data) => {
    const response = await axios.post(`${config.API_BASE_URL}/auth/reset-password`, data);
    if (response != null) {
        return response.data;
    }
    return null;
}